<template lang="html">

  <nav class="rrss row-center">
      <a target="_blank" href="https://www.facebook.com/pages/Aldonza-Gourmet/438637442941023?fref=ts"><i class="fa fa-facebook"></i></a>
<!--       <a target="_blank" href="https://twitter.com/AldonzaGourmet"><i class="fa-brands fa-x-twitter"></i></a> -->      
      <a target="_blank" href="https://www.instagram.com/aldonzagourmet/"><i class="fa fa-instagram"></i></a>
      <a target="_blank" href="https://www.youtube.com/channel/UCbgjP5f05GQqAeg8b2O5xMQ"><i class="fa fa-youtube"></i></a>
      <a target="_blank" href="https://www.tripadvisor.es/Attraction_Review-g1437533-d15780377-Reviews-Bodegas_Aldonza-Munera_Province_of_Albacete_Castile_La_Mancha.html"><i class="fa fa-tripadvisor"></i></a>
    </nav>

</template>

<script lang="js">
  export default  {
    name: 'rrss'
}
</script>

<style scoped lang="scss">
  .rrss{
  overflow: hidden;
  position: relative;
  z-index: 2;
}

.rrss a{
  width: 25px;
  height: 25px;
  margin: 0 5px;
  line-height: 25px;
  border-radius: 50%;
  border: 1px solid white;
  font-size: 14px;
  text-align: center;
  transform: translateY(150%);
  transition: .3s;
}


[show=true] .rrss a{
 transform: translateY(0%); 
}
</style>



// WEBPACK FOOTER //
// src/components/parts/rrss.vue